/// <reference types="google-publisher-tag" />
import { getGoogleTag } from 'components/ad-magnite/magnite-libs';
import { messageLog } from 'utilities/helpers/logger/message-logger';
import { AD_RESPONSE_HAS_AD, AD_RESPONSE_NO_AD } from '../advert-component';

export const createBannerAdSlotRenderEndedCB = ({ adUnitPath, origin, id, timerAdResponse, adDisplayTrueCB, adDisplayFalseCB }: { adUnitPath: string; origin: string; id: string; timerAdResponse?: (f: boolean) => void; adDisplayTrueCB?: () => void; adDisplayFalseCB?: () => void }) => {
    return (event: googletag.events.SlotRenderEndedEvent) => {
        const slotAdUnitPath = event.slot.getAdUnitPath();

        if (slotAdUnitPath !== adUnitPath) return;

        timerAdResponse?.(true);

        if (event.isEmpty) {
            messageLog.ads(`Response ${origin}: No Ad${AD_RESPONSE_NO_AD}`, { id });
            adDisplayFalseCB?.();
            return;
        }
        messageLog.ads(`Response ${origin}: Has Ad${AD_RESPONSE_HAS_AD}`, { id });
        adDisplayTrueCB?.();
    };
};

export const createInterstitialAdSlotLoadedCB = ({ adUnitPath, origin, id }: { adUnitPath: string; origin: string; id: string }) => {
    return (event: googletag.events.SlotOnloadEvent) => {
        const { getAdUnitPath } = event.slot;
        if (adUnitPath === getAdUnitPath()) {
            messageLog.ads(`Loaded ${origin}: Ad`, { id });
        }
    };
};

export const getTagSlot = ({ isInterstitial, adUnitPath, sizes, id, slotTargeting }: { isInterstitial: boolean; adUnitPath: string; sizes: googletag.GeneralSize; id: string; slotTargeting: Record<string, string[]> }) => {
    const googletag = getGoogleTag();
    if (isInterstitial) {
        const interstitialSlot = googletag.defineOutOfPageSlot(
            adUnitPath,
            googletag.enums.OutOfPageFormat.INTERSTITIAL
        )?.addService(googletag.pubads());
        interstitialSlot?.setConfig({
            interstitial: {
                triggers: {
                    // https://developers.google.com/publisher-tag/samples/display-web-interstitial-ad
                    navBar: true,
                    unhideWindow: true,
                    /**  @ts-expect-error new types not in lib    */
                    backward: true,
                    endOfArticle: true,
                    inactivity: true,
                },
            },
        });
        return interstitialSlot ?? undefined;
    }

    const bannerSlot = googletag.defineSlot(adUnitPath, sizes, id)?.addService(googletag.pubads());
    bannerSlot?.setConfig({
        targeting: slotTargeting,
        collapseDiv: 'ON_NO_FILL',
    });

    return bannerSlot ?? undefined;
};
